export default __webpack_public_path__ + "static/media/feature.552d41c0.png";